import { createClient as createNextSanityClient, type ClientPerspective, type FilterDefault, type StegaConfig } from 'next-sanity';

export type BaseClientOptions = {
  projectId: string;
  dataset: string;
  apiVersion: string;
  token?: string;
  perspective?: ClientPerspective;
  studioUrl?: string;
  stegaFilter?: (props: Parameters<FilterDefault>[0]) => boolean;
  useCdn?: boolean;
};

function buildStegaConfig(studioUrl?: string, stegaFilter?: (props: Parameters<FilterDefault>[0]) => boolean): StegaConfig {
  return {
    studioUrl,
    filter: ((props: Parameters<FilterDefault>[0]) => {
      if (typeof stegaFilter === 'function') return stegaFilter(props);
      if (String(props.sourcePath.at(-1)) === 'title') return true;
      return props.filterDefault(props);
    }) as FilterDefault,
  } satisfies StegaConfig;
}

export function createBaseClient({
  projectId,
  dataset,
  apiVersion,
  token,
  perspective = 'raw',
  studioUrl,
  stegaFilter,
  useCdn = true,
}: BaseClientOptions) {
  return createNextSanityClient({
    projectId,
    dataset,
    apiVersion,
    token,
    perspective,
    useCdn,
    stega: buildStegaConfig(studioUrl, stegaFilter),
  });
}

export function createNoCdnClient(options: BaseClientOptions) {
  return createBaseClient({ ...options, useCdn: false });
}
